var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3258_4381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.79 9.00001C17.79 4.2911 13.9725 0.473694 9.26362 0.473694C4.55471 0.473694 0.737305 4.2911 0.737305 9.00001C0.737305 12.9985 3.49028 16.3538 7.204 17.2753V11.6057H5.44588V9.00001H7.204V7.87726C7.204 4.97525 8.5174 3.63014 11.3665 3.63014C11.9068 3.63014 12.8389 3.7362 13.2201 3.84193V6.20372C13.0189 6.18257 12.6693 6.172 12.2353 6.172C10.8372 6.172 10.297 6.70166 10.297 8.07849V9.00001H13.082L12.6036 11.6057H10.297V17.4639C14.5189 16.954 17.79 13.3593 17.79 9.00001Z",
    fill: "#484848"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3258_4381"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFb);
export default __webpack_public_path__ + "static/media/ic_fb.2126c066.svg";
export { ForwardRef as ReactComponent };